import React from 'react';
import { IconProps } from '../types/types';

const MATICMAINNET: React.FC<IconProps> = (props) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1033 1033" role="img" {...props}><path d="M516.5 946.917c237.713 0 430.417-192.704 430.417-430.417 0-237.713-192.704-430.417-430.417-430.417-237.713 0-430.417 192.704-430.417 430.417 0 237.713 192.704 430.417 430.417 430.417Z" fill="#3970E7"/><path fillRule="evenodd" clipRule="evenodd" d="m335.424 295.911-90.517 51.392v319.542l90.517 51.434 90.559-51.434V552.956l90.517 51.349 90.387-51.392h.173v114.706l90.516 51.435.56-1.119 89.957-51.133V347.346l-90.517-51.391-90.516 51.391v102.827L335.424 295.911Z" fill="#fff"/></svg>
);

export default MATICMAINNET;
